let loadPromise: Promise<void> | null = null;

/**
 * Loads the Google Maps JavaScript API with the Places library once.
 * Resolves when window.google.maps.places is available.
 * Uses REACT_APP_GOOGLE_PLACES_API_KEY from env.
 */
export function loadGoogleMaps(): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("loadGoogleMaps must run in browser"));
  }
  if (window.google?.maps?.places) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }
  const key = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
  if (!key) {
    return Promise.reject(new Error("REACT_APP_GOOGLE_PLACES_API_KEY is not set"));
  }
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.google?.maps?.places) {
        resolve();
      } else {
        const check = setInterval(() => {
          if (window.google?.maps?.places) {
            clearInterval(check);
            resolve();
          }
        }, 50);
        setTimeout(() => {
          clearInterval(check);
          if (!window.google?.maps?.places) {
            reject(new Error("Google Maps Places failed to load"));
          }
        }, 10000);
      }
    };
    script.onerror = () => reject(new Error("Failed to load Google Maps script"));
    document.head.appendChild(script);
  });
  return loadPromise;
}
